/**
 * banner
 */

import $ from 'jquery';

// Module dependencies
import 'protons';

// Module template
import './_banner.css';
import './_banner.twig';

export const name = 'banner';

export const defaults = {
  dummyClass: 'js-banner-exists',
};

/**
 * Components may need to run clean-up tasks if they are removed from DOM.
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Pertinent settings
 */
// eslint-disable-next-line no-unused-vars
export function disable($context, settings) {}

/**
 * Each component has a chance to run when its enable function is called. It is
 * given a piece of DOM ($context) and a settings object. We destructure our
 * component key off the settings object and provide an empty object fallback.
 * Incoming settings override default settings via Object.assign().
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Settings object
 */
export function enable($context, { banner = {} }) {
  // Find our component within the DOM
  const $banner = $('.banner', $context);
  // Bail if component does not exist
  if (!$banner.length) {
    return;
  }
  // Merge defaults with incoming settings
  const settings = {
    ...defaults,
    ...banner,
  };
  // An example of what could be done with this component
  $banner.addClass(settings.dummyClass);

  // When clicking the banner.
  $(document).on('click', '.banner', function bannerClick(e) {
    // Get URL property associated to banner if any.
    const url = $(this).data('link_url');
    if (!url) {
      return;
    }

    // Prevent default action.
    e.preventDefault();

    // Check if CTA or link is clicked.
    if ($(e.target).is('a') || $(e.target).hasClass('button__text')) {
      // Get link.
      let link = $(e.target);

      // Check if clicked on child of <a>.
      if (link.hasClass('button__text')) {
        link = $(e.target).parent();
      }

      // Trigger link action.
      const target = link.attr('target') ? link.attr('target') : '_self';
      window.open(link.attr('href'), target);
    } else {
      // Redirect to banner action.
      window.location.href = url;
    }
  });
}

export default enable;
